<div class="text-paragraph">

    <hpo-placeholder *ngIf="loading"
        type="row"></hpo-placeholder>

    <div *ngIf="!loading"
        class="text-paragraph__content"
        [innerHTML]="sanitizedHtml"></div>

</div>